import { render, staticRenderFns } from "./SelectableList.vue?vue&type=template&id=dfb4d988&"
import script from "./SelectableList.vue?vue&type=script&lang=js&"
export * from "./SelectableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports